import {
  type CommonTranslationFunction,
  type MainTranslationFunction,
} from '@autone/translations';

import { type APP_NAME } from '../../../consts';
import {
  type AssortmentAdvancedFilterColumnIds,
  type AssortmentAdvancedFilterOperatorIds,
} from '../../../storage/session-storage';

export const getAdvancedFilterFieldTranslations = (
  t: MainTranslationFunction<typeof APP_NAME>,
) =>
  ({
    lifetime_sales_units: t('table-columns.total-sales-units'),
    lifetime_sales_value: t('table-columns.total-sales-value'),
    store_inventory_units: t('table-columns.store-units'),
    warehouse_inventory_units: t('table-columns.warehouse-units'),
    inventory_units: t('table-columns.current-units'),
    parent_location_inventory_units: t('table-columns.warehouse-units'),
    first_sale_date: t('table-columns.first-sale-date'),
    latest_sale_date: t('table-columns.latest-sale-date'),
    initial_allocation: t('table-columns.initial-allocation'),
    assorted_start_date: t('table-columns.scheduled-assortment-start'),
    assorted_end_date: t('table-columns.scheduled-assortment-end'),
    is_assorted: t('table-columns.current-assortment'),
    warehouse_pending_from_production_units: t(
      'table-columns.warehouse-pending-from-production-units',
    ),
    parent_location_pending_from_production_units: t(
      'table-columns.parent-location-pending-from-production-units',
    ),
    pending_from_production_units: t(
      'table-columns.pending-from-production-units',
    ),
  }) as const satisfies Record<AssortmentAdvancedFilterColumnIds, string>;

export const getAdvancedFilterOperatorTranslations = (
  common: CommonTranslationFunction,
) =>
  ({
    eq: common('advanced-filters.equal-to'),
    gt: common('advanced-filters.greater-than'),
    lt: common('advanced-filters.lower-than'),
    ge: common('advanced-filters.greater-than-equal'),
    le: common('advanced-filters.lower-than-equal'),
    is: common('advanced-filters.is'),
  }) as const satisfies Record<AssortmentAdvancedFilterOperatorIds, string>;
